const types = {
    newsChange: 'new - change',
    newNit: 'new - nit',
    newAcount: 'new - acount',
    suma: 'suma'
    
}


export {types}